import _ from 'lodash'

class subscriptionHelpOffreAutomne2018Ctrl {
    /** @ngInject */
    constructor($stateParams, ContactTelephone) {
        this.$stateParams = $stateParams
        this.ContactTelephone = ContactTelephone
        this.logoMapping = {
            famille: 'famille.png',
            selectra: 'selectra.png',
        }
    }

    $onInit() {
        this.logo = _.get(this.logoMapping, _.toLower(this.$stateParams.id_presta), 'selectra.png')
    }
}

export default {
    template: require('./subscriptionHelpOffreAutomne2018.jade')(),
    controller: subscriptionHelpOffreAutomne2018Ctrl,
    bindings: {
        contractDraft: '<',
    },
}



// WEBPACK FOOTER //
// ./src/states/subscription/component/subscriptionHelpOffreAutomne2018.js